// extracted by mini-css-extract-plugin
module.exports = {"block":"footer_block__2ML-1","social":"footer_social__2TyNA","link":"footer_link__3_j5B","copyright":"footer_copyright__2QWCI","contacts":"footer_contacts__3UnN-"};